import apiClient from './apiClient';

// ============================================================
// PW030A - 等級-人員清冊 API types and client
// ============================================================

export interface PW030AReportRow {
  f003_01: string;   // 員工代號
  f003_12: string;   // 等級代碼
  f901_11: string;   // 姓名
  f901_31: string;   // 到職日
  f901_32: string;   // 部門代碼
  f901_34: string;   // 離職日 (空=在職)
}

export interface PW030AReportResponse {
  items: PW030AReportRow[];
  total: number;
}

export interface PW030AReportParams {
  startGrade?: string;
  endGrade?: string;
  excludeDeparted?: boolean;
}

export const pw030aApi = {
  async getReport(params: PW030AReportParams): Promise<PW030AReportResponse> {
    const query: Record<string, string> = {};
    if (params.startGrade)    query['startGrade']    = params.startGrade;
    if (params.endGrade)      query['endGrade']      = params.endGrade;
    if (params.excludeDeparted !== undefined) {
      query['excludeDeparted'] = params.excludeDeparted ? 'true' : 'false';
    }
    return (await apiClient.get('/api/pw030a/report', { params: query })).data;
  },
};
